/* Baminger-Warenkorb: Gruppen und Cart-Transform-Bündel vollständig entfernen.
   Während einer Änderung bleiben weitere Entfernen-Aktionen gesperrt. */
(function () {
  if (window.__dsBamWarenkorb) return;
  window.__dsBamWarenkorb = true;
  var entfernt = false;

  document.addEventListener('click', async function (e) {
    var knopf = e.target && e.target.closest
      ? e.target.closest('[data-ds-bam-entfernen], [data-ds-bam-buendel-entfernen]') : null;
    if (!knopf) return;
    e.preventDefault();
    e.stopPropagation();
    if (entfernt) return;

    var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var buendel = knopf.getAttribute('data-ds-bam-buendel-entfernen');
    var gruppe = knopf.getAttribute('data-ds-bam-entfernen');
    var updates = {};
    if (!buendel) {
      document.querySelectorAll('tr[data-bam-gruppe]').forEach(function (zeile) {
        if (zeile.getAttribute('data-bam-gruppe') === gruppe) {
          updates[zeile.getAttribute('data-key')] = 0;
        }
      });
      if (!Object.keys(updates).length) return;
    }

    entfernt = true;
    var controls = Array.from(document.querySelectorAll(
      'cart-items-component button, cart-items-component input, #checkout'
    )).map(function (element) {
      var vorher = element.disabled;
      element.disabled = true;
      return {element: element, disabled: vorher};
    });
    var meldung = document.createElement('p');
    meldung.className = 'cart-item__error';
    meldung.setAttribute('role', 'status');
    meldung.textContent = 'Wird entfernt …';
    knopf.closest('td').appendChild(meldung);
    try {
      // Bündel immer über den eindeutigen Schlüssel entfernen: Nach einer
      // anderen Warenkorbänderung kann dieselbe Zeilennummer etwas anderes sein.
      var events = await import('@shopify/events');
      var sektionen = Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component'))
        .map(function (element) { return element.dataset.sectionId; }).filter(Boolean))).slice(0, 5);
      var daten = buendel ? {id: buendel, quantity: 0} : {updates: updates};
      daten.sections = sektionen.join(',');
      daten.sections_url = window.location.pathname;
      var antwort = await fetch(wurzel + (buendel ? 'cart/change.js' : 'cart/update.js'), {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify(daten)
      });
      var korb = await antwort.json();
      if (!antwort.ok || korb.errors || !Array.isArray(korb.items)) {
        throw new Error('Entfernen fehlgeschlagen');
      }
      var uebrig = korb.items.some(function (item) {
        return buendel ? item.key === buendel :
          (item.properties && item.properties._bam_gruppe === gruppe);
      });
      if (uebrig) throw new Error('Artikel wurde nicht entfernt');
      // Das Theme aktualisiert seine Warenkorb-Sektionen im bestehenden Dialog.
      // Den Dialog selbst nicht ersetzen und keine neue Seitennavigation auslösen.
      var aktualisiert = new Promise(function (resolve, reject) {
        var timer;
        var beobachter = new MutationObserver(pruefen);
        function pruefen() {
          var vorhanden = Array.from(document.querySelectorAll('cart-items-component tr[data-key]'))
            .some(function (zeile) {
              return buendel ? zeile.getAttribute('data-key') === buendel :
                zeile.getAttribute('data-bam-gruppe') === gruppe;
            });
          if (!vorhanden) {
            beobachter.disconnect();
            clearTimeout(timer);
            resolve();
          }
        }
        beobachter.observe(document.body, {childList: true, subtree: true});
        timer = setTimeout(function () {
          beobachter.disconnect();
          reject(new Error('Warenkorbansicht konnte nicht aktualisiert werden'));
        }, 10000);
        pruefen();
      });
      var fertig = events.CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new events.CartLinesUpdateEvent({
        action: 'remove', context: 'cart', lines: [], promise: fertig.promise
      }));
      fertig.resolve({
        cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(korb),
        detail: {sections: korb.sections, items: korb.items, itemCount: korb.item_count,
          source: 'ds-bam-warenkorb', didError: false}
      });
      await aktualisiert;
      entfernt = false;
      controls.forEach(function (control) {
        if (control.element.isConnected) control.element.disabled = control.disabled;
      });
    } catch (error) {
      entfernt = false;
      controls.forEach(function (control) { control.element.disabled = control.disabled; });
      meldung.setAttribute('role', 'alert');
      meldung.textContent = 'Der Artikel konnte nicht entfernt werden. Bitte versuche es erneut.';
    }
  }, true);
})();